import { write as writeEvent } from 'js/core_webpack/arbitrary_events';

export const logError = (error: string, httpCode?: number, url?: string) =>
  writeEvent('MentionsError', {
    error,
    http_code: httpCode,
    url,
  });

export class MentionsFetchError extends Error {}
